import {
  transformCompensationSpendingBreakdown,
  transformCompensationSummary,
} from '@/common/integrations/menhir/employee/compensation/compensation.dto';
import {
  TMenhirCompensationSpendingBreakdown,
  TMenhirCompensationSummary,
  TMenhirGetCompensationSpendingBreakdownParams,
} from '@/common/integrations/menhir/employee/compensation/compensation.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import {
  MENHIR_ENDPOINTS,
  endpointFor,
} from '@/common/integrations/menhir/menhir.endpoints';

export const getCompensationSummary = () =>
  menhirClient
    .get<
      null,
      { summary: TMenhirCompensationSummary }
    >(MENHIR_ENDPOINTS.EMPLOYEE.COMPENSATION.ROOT)
    .then(({ summary }) => transformCompensationSummary(summary));

export const getCompensationSpendingBreakdown = ({
  category_slug,
  filters,
}: TMenhirGetCompensationSpendingBreakdownParams) =>
  menhirClient
    .get<null, { breakdown: TMenhirCompensationSpendingBreakdown }>(
      endpointFor(
        MENHIR_ENDPOINTS.EMPLOYEE.COMPENSATION.SPENDING_BREAKDOWN,
        category_slug
      ),
      {
        params: {
          filters,
        },
      }
    )
    .then(({ breakdown }) => transformCompensationSpendingBreakdown(breakdown));
